<template>
	<div class="container">
		<PageHeader></PageHeader>
		<router-view />
		<PageFooter></PageFooter>
	</div>
</template>

<script>
	import PageFooter from './components/footer.vue'
	import PageHeader from './components/header.vue'
	import translate from 'i18n-jsautotranslate'

	export default {
		components: {
			PageFooter,
			PageHeader
		},
		data() {
			return {
				url: ''
			}
		},
		methods: {},
		mounted() {
			translate.selectLanguageTag.show = false
			translate.ignore.id.push('element');
			translate.ignore.id.push('logoMain');
			translate.ignore.id.push('home');
		}
	}
</script>

<style>
	html,
	body,
	#app {
		min-width: 1200px;
		min-height: 100vh;
		margin: 0;
		padding: 0;
		background-color: rgba(235, 242, 250, 1);
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}

	main {
		flex: 1;
	}

	.container {
		margin: 0;
		padding: 0;
		min-height: 100vh;
	}

	/* 平板设备 */
	@media (max-width: 1024px) {
		.container {
			width: 90%;
			height: auto;
		}
	}

	/* 手机设备 */
	@media (max-width: 768px) {
		.container {
			width: 100%;
			padding: 0 10px;
			height: auto;
		}
	}


	.el-timeline-item__timestamp {
		position: absolute !important;
		top: -5px !important;
		left: -80px !important;
	}
</style>